// removed by extract-text-webpack-plugin
module.exports = {"aside":"_1NVMg","isShown":"_1tSg0","slideIn":"shC-B","isHidden":"_3YGnr","close":"_2AZDj","content":"_1FSVu","fadeIn":"_1jITn","title":"_3yS7B","text":"_2c07H","images":"_24lFz","image":"_3--_s","link":"_2z-4f"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/styles.css
 ** module id = 337
 ** module chunks = 0
 **/